"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _itemSummary = _interopRequireDefault(require("../../item-summary"));
var _configContext = require("../../context/config-context");
var _functions = require("../../utils/functions");
var _growl = _interopRequireDefault(require("@site/pattern-library-core/growl"));
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-console */

const GrowlCustom = /*#__PURE__*/(0, _react2.styled)(_growl.default)({
  name: "GrowlCustom",
  class: "pc-ge9bc1a"
});

/**
 * SummaryWrapper Component.
 *
 * @param {Object} props React props
 * @returns {React.ReactElement} SummaryWrapper Component
 * @public
 */
function SummaryWrapper() {
  const [loading, setLoading] = (0, _react.useState)(false);
  const [showError, setShowError] = (0, _react.useState)(false);
  const {
    configData,
    appParams
  } = (0, _configContext.useConfig)();
  if (!configData) {
    return null;
  }
  const {
    environment,
    instance,
    queryParams,
    itemSummary,
    commonContent
  } = configData;
  const product = appParams.get('plan'); // For non-domains products

  const {
    orderSummary,
    total,
    totalPriceOrder,
    legalTaxText,
    fixedCheckoutDescription,
    totalSavingsOrder,
    totalSavingsBanner,
    items,
    belowContinueToCartContent
  } = itemSummary;

  // Flatten selections from all items
  const allItems = items?.reduce((acc, itemObj) => {
    const productKey = Object.keys(itemObj)[0];
    const productData = itemObj[productKey];
    return acc.concat(productData.selections || []);
  }, []) || [];
  const {
    continueToCart,
    continueToCartErrorTitle,
    continueToCartErrorText,
    continueToCartErrorLink
  } = commonContent;
  const featureFlags = commonContent?.featureFlags || [];
  const redirectToCart = () => {
    window.location.href = environment.cartUrl;
  };

  // eslint-disable-next-line max-statements
  const handleClickCheckout = async () => {
    const postToCartUrl = environment.purchaseUrl;
    const skipBasket = featureFlags.includes(_constants.FEATURE_FLAGS.SKIP_BASKET);
    let cartUrl = environment.cartUrl;
    const parsedQueryParams = new URLSearchParams(queryParams);
    const cartItem = parsedQueryParams.get('cartItem');
    try {
      setLoading(true);
      const response = await (0, _functions.updateCartWithInstance)(postToCartUrl, product, instance, parsedQueryParams);
      const data = await response.json();
      if (response.status === 200) {
        // Add cart_ref=precheck query parameter based on the following conditions:
        // - skipBasket flag ON (from CMS)
        // - BFF response has skipBasket=true or query parameter cartItem=0
        const allowSkipBasket = skipBasket && (data.skipBasket || cartItem === '0');
        if (allowSkipBasket) {
          const url = new URL(cartUrl, window.location.origin);
          url.searchParams.set('cart_ref', 'precheck');
          cartUrl = url.href;
        }
        window.location.href = cartUrl;
      } else if (data.errorMessage) {
        throw new Error(data.errorMessage);
      } else {
        throw new Error('Unknown error');
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  // Hardcoded kill-switch to turn off sticky CTA
  const DISABLE_STICKY_CTA = true;
  const transformedProps = {
    id: product ? `${product}-summary` : 'summary',
    title: orderSummary,
    subTotal: {
      title: total,
      description: legalTaxText,
      subTotal: totalPriceOrder,
      fixedCheckoutDescription: fixedCheckoutDescription
    },
    totalSavings: {
      value: totalSavingsOrder,
      banner: totalSavingsBanner
    },
    belowContinueToCartContent,
    checkoutCta: {
      text: continueToCart,
      design: 'primary',
      ariaLabel: 'continue-to-cart-button',
      id: product || 'cta',
      _name: product ? `${product} ${continueToCart}` : continueToCart,
      templateName: 'Button Component',
      onClick: handleClickCheckout,
      isPromo: false,
      dataCy: 'checkout-cta'
    },
    items: allItems
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_itemSummary.default, (0, _extends2.default)({}, transformedProps, {
    loading: loading,
    disableStickyCta: DISABLE_STICKY_CTA
  })), showError && /*#__PURE__*/_react.default.createElement(GrowlCustom, {
    title: continueToCartErrorTitle || 'Oops, something went wrong.',
    icon: "alert",
    text: continueToCartErrorText || 'We\'ll redirect you to your cart. Or you can',
    linkText: continueToCartErrorLink || 'click here.',
    onLinkClick: redirectToCart,
    actionOnFadeOut: redirectToCart,
    fadeOut: "3000"
  }));
}
var _default = exports.default = SummaryWrapper;